import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

export function useDeleteManyUser() {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async (ids: string[]) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.delete('/user', {
        headers: { Authorization: `Bearer ${token}` },
        data: {
          ids
        }
      })

      if (response.data) return response.data
      throw new Error('Estrutura de resposta inesperada')
    }
  })
}
